import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import type { PageKey } from "../../types/pages";

interface Candidate {
  page: PageKey;
  href: string;
}

/**
 * Redirects to the first candidate the current user has access to.
 * Waits for auth + permissions to fully resolve before navigating.
 * Falls back to /unauthorized if no candidate passes.
 */
export function SmartRedirect({ candidates }: { candidates: Candidate[] }) {
  const { loading, user, hasPageAccess } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  const target = candidates.find((c) => hasPageAccess(c.page));
  return <Navigate to={target?.href ?? "/unauthorized"} replace />;
}
